export class AlertModel {
    message: string
    type: string
}